import { Colors } from '@oy/uicore';
import { Spacer, Text } from '@oy/uidesktop';
import { AccentIcon } from '@oy/uiicon';
import { useState } from 'react';
import { IS_WHITELABELING } from 'src/constants';
import { useTranslate } from 'src/hooks';
import { Accordion } from './Accordion';
import styles from './LoginFAQ.module.css';
import { FAQ } from './constants';

export const LoginFAQ = () => {
  const [activeFAQ, setActiveFAQ] = useState(0);

  const { getTranslation } = useTranslate();

  return (
    <>
      <Text textStyle={Text.Style.HeadingLg} color={Colors.BLACK80}>
        {getTranslation('login_helpCenter_title')}
      </Text>
      <div className={styles.accordionItems}>
        {FAQ.map((data, index) => {
          const { id, points } = data;
          const translateKey = `login_helpCenter_${id}`;
          const items: JSX.Element[] = [];
          for (let i = 0; i < points; i++) {
            items.push(
              <li key={i}>
                {getTranslation(`${translateKey}_point${i + 1}`)}
              </li>,
            );
          }
          return (
            <Accordion
              key={translateKey}
              title={getTranslation(`${translateKey}_title`)}
              isActive={activeFAQ === index}
              onToggle={() => setActiveFAQ(index)}
            >
              <Text textStyle={Text.Style.BodyLgRegular}>
                {getTranslation(`${translateKey}_description`)}
                <ol>{items}</ol>
              </Text>
            </Accordion>
          );
        })}
      </div>
      {!IS_WHITELABELING && (
        <>
          <Spacer bottom={Spacer.Size.XS} />
          <Text textStyle={Text.Style.BodyMdRegular}>
            {getTranslation('login_helpCenter_needHelp')}
          </Text>
          <div className={styles.whatsapp}>
            <AccentIcon name="whatsapp" />
            <Spacer right={Spacer.Size.XXXS} />
            <Text textStyle={Text.Style.BodyMdRegular}>0851 6309 6309</Text>
          </div>
          <Spacer bottom={Spacer.Size.S} />
          <div>
            <img
              className={styles.isoWrapper}
              src="/img/iso-certificates.png"
              alt="ISO Certificates"
              height={44}
            />
            <a
              href="https://oyindonesia.qrcsolutionz.com"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="/img/pcidss.svg"
                height={44}
                width={44}
                alt="PCI DSS Certified by QRC"
              />
            </a>
          </div>
        </>
      )}
    </>
  );
};
